import _ from 'lodash';
import allModelData from '@/admin_models/all';

export const modelData = _.merge({}, allModelData, {
  'NormalComment': {
    label: 'content'
  },
  'User': {
    label: 'screen_name'
  },
  'ApplyRecord': {
    label: 'price_type_name'
  },
})

export const getLabel = ({ item }) => {
  if (item.cn) {
    const label = modelData[item.cn]['label']

    if (typeof label === 'function') {
      return label(item)
    } else {
      return item[label]
    }
  }
}
